import ApiService from "@/core/services/api.service";

/**
 * Front-end seam for the Client page, Policy Maintenance, and bordereau actions.
 */

export function searchClients(query) {
  const q = encodeURIComponent(query || "");
  return ApiService.get(`/workbench/clients/search?q=${q}`).then(({ data }) => data.result);
}

export function getClientCard(clientId) {
  return ApiService.get(`/workbench/clients/${clientId}/card`).then(({ data }) => data.result);
}

export function getClientQuotes(clientId, policyId) {
  const qs = policyId ? `?policyId=${encodeURIComponent(policyId)}` : "";
  return ApiService.get(`/workbench/clients/${clientId}/quotes${qs}`).then(({ data }) => data.result);
}

export function fixClientLink(clientId, body = {}) {
  return ApiService.post(`/workbench/clients/${clientId}/fix-link`, body).then(({ data }) => data.result);
}

export function getBrokerLinkStatus(clientId, options = {}) {
  const params = new URLSearchParams();
  if (options.transactionId) params.set("transactionId", String(options.transactionId));
  if (options.rowSubagentId) params.set("rowSubagentId", String(options.rowSubagentId));
  if (options.policyId) params.set("policyId", String(options.policyId));
  const qs = params.toString();
  return ApiService.get(
    `/workbench/clients/${clientId}/broker-link-status${qs ? `?${qs}` : ""}`
  ).then(({ data }) => data.result);
}

export function linkClientBroker(clientId, body = {}) {
  return ApiService.post(`/workbench/clients/${clientId}/link-broker`, body).then(({ data }) => data.result);
}

export function ensureBrokerGold(clientId, body = {}) {
  return ApiService.post(`/workbench/clients/${clientId}/ensure-broker-gold`, body).then(
    ({ data }) => data.result
  );
}

export function ensureClientGold(clientId, body = {}) {
  return ApiService.post(`/workbench/clients/${clientId}/ensure-client-gold`, body).then(
    ({ data }) => data.result
  );
}

export function searchInsightProducingBrokers(query) {
  const q = encodeURIComponent(query || "");
  return ApiService.get(`/workbench/producing-brokers/insight-search?q=${q}`).then(
    ({ data }) => data.result
  );
}

export function getInsightBrokerCreateCapability() {
  return ApiService.get(`/workbench/producing-brokers/insight-create-capability`).then(
    ({ data }) => data.result
  );
}

export function copyPriorQuote(sourceQuoteId, body = {}) {
  return ApiService.post(`/workbench/quotes/${sourceQuoteId}/copy`, body).then(({ data }) => data.result);
}

export function getPolicyCard(policyId) {
  return ApiService.get(`/workbench/policies/${policyId}/card`).then(({ data }) => data.result);
}

export function createPolicyEndorsement(policyId, body = {}) {
  return ApiService.post(`/workbench/policies/${policyId}/endorsements`, body).then(
    ({ data }) => data.result
  );
}

export function lookupEndorsementVehicle(body = {}) {
  return ApiService.post("/workbench/endorsements/vehicle-lookup", body).then(
    ({ data }) => data.result
  );
}

export function getEndorsementWork(transactionId) {
  return ApiService.get(`/workbench/endorsements/${transactionId}`).then(({ data }) => data.result);
}

export function applyEndorsementWork(transactionId, body = {}) {
  return ApiService.post(`/workbench/endorsements/${transactionId}/apply`, body).then(
    ({ data }) => data.result
  );
}

export function rateEndorsementWork(transactionId) {
  return ApiService.post(`/workbench/endorsements/${transactionId}/rate`, {}).then(
    ({ data }) => data.result
  );
}

export function stampEndorsementSuccessor(transactionId) {
  return ApiService.post(`/workbench/endorsements/${transactionId}/stamp`, {}).then(
    ({ data }) => data.result
  );
}

export function getPolicyMaintenance(params = {}) {
  const qs = new URLSearchParams();
  if (params.start) qs.set("start", params.start);
  if (params.end) qs.set("end", params.end);
  if (params.showDone) qs.set("showDone", "true");
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return ApiService.get(`/workbench/policy-maintenance${query}`).then(({ data }) => data.result);
}

export function previewBordereau(params = {}) {
  const qs = new URLSearchParams();
  if (params.start) qs.set("start", params.start);
  if (params.end) qs.set("end", params.end);
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return ApiService.get(`/workbench/msi-bdx/preview${query}`).then(({ data }) => data.result);
}

export function exportBordereauUrl(params = {}) {
  const qs = new URLSearchParams();
  if (params.start) qs.set("start", params.start);
  if (params.end) qs.set("end", params.end);
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return `/workbench/msi-bdx/export${query}`;
}

export function getProducingBrokers() {
  return ApiService.get(`/workbench/producing-brokers`).then(({ data }) => data.result);
}
